import {
  serviceRetryingMessage,
  serviceUnavailableMessage,
} from "../../constants/serviceUnavailableMessages";
import { useServiceAvailability } from "../../hooks/useServiceAvailability";
import styles from "./ServiceUnavailableBanner.module.css";

export function ServiceUnavailableBanner() {
  const availability = useServiceAvailability();

  if (availability.state === "available") {
    return null;
  }

  return (
    <div className={styles.serviceUnavailableBanner} role="status">
      {availability.state === "retrying"
        ? serviceRetryingMessage(availability.service)
        : serviceUnavailableMessage(availability.service)}
    </div>
  );
}
